export enum SURFACE_TYPE {
    m = "m",
    ft = "ft",
}
